/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessDrawsParticipations.internal

import features.userBusinessDrawsParticipations.models.ParticipationsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessDrawsParticipationsRequest : NetworkRequest() {

    suspend fun getUserBusinessDrawsParticipations(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<ParticipationsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessDrawsParticipationsEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
